import { get, post } from '@/axios'

/**
 * @description 删除评论
 * 
 */
export function deleteComment(data = {}) {
  return post('/moment/comment/delete', data)
}

/**
 * @description 删除动态
 */
export function deleteDynamic(data = {}) {
  return post('/moment/moment/delete', data)
}

/**
 * @description 删除回复
 * 
 */
export function deleteReply(data = {}) {
  return post('/moment/reply/delete', data)
}

/**
 * @description 获取評論列表
 */
export function getCommentList(data = {}) {
  return post('moment/comment/list', data)
}

/**
 * @description 查询动态信息
 * 
 */
export function getMomentInfo(params = {}) {
  return get('/moment/moment/detail', params)
}

/**
 * @description 獲取回覆列表
 */
export function getReplyList(data = {}) {
  return post('/moment/reply/list', data)
} 

/**
 * @description 點贊動態
 * 
 */
export function likeMoment(data = {}) {
  return post('/moment/moment/like', data)
}

/**
 * @description 發表留言
 * 
 */
export function writeMomentComment(data = {}) {
  return post('/moment/comment/write', data)
}

/**
 * @description 回复留言
 * 
 */
export function writeMomentReply(data = {}) {
  return post('/moment/reply/write', data)
}

